import * as React from "react";
import { connect } from "react-redux";
import { queryParams } from "../../../../helpers/formatting";
import { logUI } from "../../../../api/andyliticsApi";
import { getURLPath } from '../../../../helpers/Tools';

//Added Flu Redirect deeplink component due to further may need any customization.
class ScheduleFluVaccineRedirect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ScheduleFluVaccineRedirect.ComponentDidMount", new Date(), getURLPath());
        let vaccineFluSearchParams = "?" + queryParams({
            keyword: 'Flu Vaccine',
            tab: 2,
            vector: 'clinicalTerm'
        });
        this.props.history.push({
            pathname: '/findcare', searchParms: vaccineFluSearchParams });
        return;
    }

    componentDidUpdate(prevProps) {
    }


    render() {
        return <div></div>
    }

}
const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleFluVaccineRedirect);